import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import { api } from "../lib/api";

export default function BookingPayPal({ config, getBooking, onPaid }) {
  return (
    <div data-testid="booking-paypal">
      <PayPalScriptProvider options={{ clientId: config.client_id, currency: config.currency, intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "sharp", label: "pay" }}
          createOrder={async () => {
            const booking = getBooking();
            if (!booking) {
              toast.error("Please fill in your name, email, service and preferred date first.");
              throw new Error("invalid-booking");
            }
            const { data } = await api.post("/payments/create-order", { package_id: "consultation", booking });
            return data.order_id;
          }}
          onApprove={async (data) => {
            try {
              const { data: res } = await api.post("/payments/capture-order", { order_id: data.orderID });
              if (res.status === "COMPLETED") {
                toast.success("Payment received — your consultation is booked!");
                onPaid();
              } else {
                toast.error("Payment not completed. Please try again.");
              }
            } catch {
              toast.error("We couldn't confirm your payment. Please contact us.");
            }
          }}
          onError={() => toast.error("PayPal encountered an error. Please try again.")}
        />
      </PayPalScriptProvider>
    </div>
  );
}
